(function () {
	document.querySelectorAll("[data-toggle]").forEach((element) => {
		let toggleElement = document.querySelector(element.dataset.toggle);
		element.setAttribute("aria-controls", element.dataset.toggle);

		// On init all items will be set as outside of the tabindex
		toggleElement.querySelectorAll("*").forEach((link) => {
			if (link.matches("button, a")) {
				link.setAttribute("tabindex", "-1");
			}
		});

		element.addEventListener("click", (event) => {
			handleToggleElement();
		});

		// Add escape key listener
		document.addEventListener("keydown", (event) => {
			// Ignore IME composition
			if (event.isComposing || event.keyCode === 229) {
				return;
			}

			// Close menu with ESC key
			if (event.key === "Escape") {
				if (toggleElement.classList.contains("active")) {
					handleToggleElement();
				}
			}
		});

		function handleToggleElement() {
			element.classList.toggle("active");
			toggleElement.classList.toggle("active");

			if (toggleElement.classList.contains("active")) {
				// Opening
				toggleElement.setAttribute("aria-expanded", "true");

				toggleElement.querySelectorAll("*").forEach((link) => {
					if (link.matches("button, a")) {
						link.setAttribute("tabindex", "0");
					}
				});
			} else {
				// Closing
				toggleElement.setAttribute("aria-expanded", "false");

				toggleElement.querySelectorAll("*").forEach((link) => {
					if (link.matches("button, a")) {
						link.setAttribute("tabindex", "-1");
					}
				});

				// Focus back on the button when closing
				element.focus();
			}
		}
	});
})();
